<template>
  <CommonPageShell
    :title="text.create.page.title"
    :subtitle="text.create.page.subtitle"
    :actions="headerActions"
    @action="onHeaderAction"
  >
    <template #content>
      <section class="invoice-create-page">
        <ExpenseReceiptCreateTopSection
          :text="text"
          :supplier-options="filteredSupplierOptions"
          :selected-supplier="selectedSupplier"
          :collaborator-options="collaboratorOptions"
          :selected-collaborator="selectedCollaborator"
          :pay-to="info.payTo"
          :payment-form-options="paymentFormOptions"
          :payment-account-options="paymentAccountOptions"
          :info="info"
          :currency="currency"
          :exchange-rate="exchangeRate"
          :supplier-pending-amount="supplierPendingAmount"
          :document-type-options="documentTypeOptions"
          @select-supplier="selectSupplier"
          @select-collaborator="selectCollaborator"
          @info-change="onInfoChange"
          @update:currency="onCurrencyChange"
          @update:exchange-rate="onExchangeRateChange"
        />

        <ExpenseReceiptCreateApplicationSection
          :text="text"
          :documents="applicationDocuments"
          :loading="loadingPendingDocuments"
          :voucher-type="info.voucherType"
          :currency="currency"
          :received-amount="Number(info.receivedAmount || 0)"
          @update-application="onApplicationAmountChange"
          @toggle-liquidate="onToggleApplicationLiquidate"
        />

        <ExpenseReceiptCreateBottomSection
          :total="appliedTotalAmount"
          :currency="currency"
        />

        <ExpenseReceiptCreateFooterActions
          :submitting="submitting"
          @submit="submitPayment"
        />

        <ExpenseReceiptCreateConfirmSubmitModal
          :show="showSubmitConfirmModal"
          :text="text"
          :mode="submitConfirmMode"
          :voucher-type="info.voucherType"
          :submitting="submitting"
          :supplier-name="submitSummary.supplierName"
          :voucher-type-label="submitSummary.voucherTypeLabel"
          :counterpart-label="submitSummary.counterpartLabel"
          :payment-info="submitSummary.paymentInfo"
          :items="submitSummary.items"
          :total-amount="submitSummary.totalAmount"
          :currency="currency"
          :exchange-rate="exchangeRate"
          @close="closeSubmitConfirmation"
          @confirm="confirmSubmitPayment"
        />
      </section>
    </template>
  </CommonPageShell>
</template>

<script>
import CommonPageShell from '@/components/common/CommonPageShell.vue';
import ExpenseReceiptCreateTopSection from '@/components/expenseReceipts/create/ExpenseReceiptCreateTopSection.vue';
import ExpenseReceiptCreateApplicationSection from '@/components/expenseReceipts/create/ExpenseReceiptCreateApplicationSection.vue';
import ExpenseReceiptCreateBottomSection from '@/components/expenseReceipts/create/ExpenseReceiptCreateBottomSection.vue';
import ExpenseReceiptCreateFooterActions from '@/components/expenseReceipts/create/ExpenseReceiptCreateFooterActions.vue';
import ExpenseReceiptCreateConfirmSubmitModal from '@/components/expenseReceipts/create/ExpenseReceiptCreateConfirmSubmitModal.vue';
import { useDomainText } from '@/composables/text/useDomainText';
import {
  createExpenseReceiptCreateState,
  expenseReceiptCreateComputed,
  expenseReceiptCreateMethods,
} from '@/composables/expenseReceipts/useExpenseReceiptCreatePage';

const { catalog: expenseReceiptsText } = useDomainText('expenseReceipts');

export default {
  name: 'ExpenseReceiptCreatePage',
  components: {
    CommonPageShell,
    ExpenseReceiptCreateTopSection,
    ExpenseReceiptCreateApplicationSection,
    ExpenseReceiptCreateBottomSection,
    ExpenseReceiptCreateFooterActions,
    ExpenseReceiptCreateConfirmSubmitModal,
  },
  data() {
    return {
      text: expenseReceiptsText,
      ...createExpenseReceiptCreateState(expenseReceiptsText),
    };
  },
  created() {
    this.initializePage();
  },
  computed: expenseReceiptCreateComputed,
  methods: expenseReceiptCreateMethods,
};
</script>
